<template>
    <div :class="['showMore',{'special':spec}]"  @click="negationMore()" :style="{width:(isPC && !spec)?'1200px':'100%'}">
        <div class="image"><img :style="showMore?'':'transform: rotate(180deg)'" src="../assets/image/images/open_icon_blue.png" alt=""></div>
        <div class="text"><span>{{showMore ? '点击查看更多' : '点击收起'}}</span></div>
    </div>  
</template>
<script >
export default {
    name:'showMore',
    props:{
        spec:String
    },
    data(){
        return{
            showMore: this.spec || this.getQuery('showMore') ? true : false,
        }
    },
    computed:{
        isPC () {
            if (window.innerWidth > 768 ) {
                return true;
            } else {
                 return false; 
            }
        }
    },
    methods:{
        negationMore(){
            this.showMore = !this.showMore
            this.$emit('getMore')
        }
    }
}
</script>
<style scoped>
.showMore{
  margin: 0 auto 20px;
  cursor: pointer;
}
.showMore.retract:hover .text{
  color: #2f8eed;
  background-color: #ecf6ff;
}
.showMore .text{
  height:45px;
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  background-color: #f7f7f7;
  color: #999;
  border-radius: 6px;
}
.showMore .text a{
  margin-right: 10px;
}
.showMore .image{
  text-align: center; 
  margin-bottom: 10px;
}
.showMore .image img{
  width: 12px;
  height: 12px;
}
.special{
    padding: 10px 20px 0;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/template/showMore.vue